import { createContext, useContext } from 'react'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import type { OfferVehicle } from 'BrokerTsLib/src/dtos'

export const carkulkaOffersContext = createContext<IOffersContext<OfferVehicle>>(defaults as any)

function CarkulkaOffersProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      insuranceParamsId={props.insuranceParamsId}
      isContract={props.isContract}
      forceCalculation={props.forceCalculation}
      signalRCalcFinishedEventName='CalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={carkulkaOffersContext as any}
    >
      {props.children}
    </OffersProvider >
  )
}

export default CarkulkaOffersProvider



export const useCarkulkaOffersContext = () => {
  const context = useContext(carkulkaOffersContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useCarkulkaOffersContext must be used within a CarkulkaOffersProvider!')
  }

  return context
}